import React from "react";
import { Owner } from "../../../types/modules/admin/Owner";
import { Mail, Phone, MapPin, User, CheckCircle, XCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { formatPhoneNumber } from "../../../utils/formatNumber";

interface Props {
  owner: Owner;
}

const OwnerDetailsCard: React.FC<Props> = ({ owner }) => {
    const {t} = useTranslation();
  return (
    <div className="max-w-3xl mx-auto p-8 bg-white shadow-xl rounded-2xl border border-gray-200">
      <h2 className="text-3xl font-bold mb-6 text-Black text-center capitalize">{t('OwnerDetails')}</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Name */}
        <div className="flex items-center gap-3 p-4 bg-gray-50 rounded-xl shadow-sm">
          <User className="w-6 h-6 text-blue-500" />
          <div>
            <p className="text-gray-500 text-sm capitalize">{t("name")}</p>
            <p className="text-gray-800 font-medium">{owner.name || "N/A"}</p>
          </div>
        </div>

        {/* Email */}
        <div className="flex items-center gap-3 p-4 bg-gray-50 rounded-xl shadow-sm">
          <Mail className="w-6 h-6 text-green-500" />
          <div>
            <p className="text-gray-500 text-sm capitalize">{t("email")}</p>
            <p className="text-gray-800 font-medium">{owner.email || "N/A"}</p>
          </div>
        </div>

        {/* Phone */}
        <div className="flex items-center gap-3 p-4 bg-gray-50 rounded-xl shadow-sm">
          <Phone className="w-6 h-6 text-yellow-500" />
          <div>
            <p className="text-gray-500 text-sm capitalize">{t("phone")}</p>
            <p className="text-gray-800 font-medium">{formatPhoneNumber(owner.phone)}</p>
          </div>
        </div>

        {/* City */}
        <div className="flex items-center gap-3 p-4 bg-gray-50 rounded-xl shadow-sm">
          <MapPin className="w-6 h-6 text-purple-500" />
          <div>
            <p className="text-gray-500 text-sm capitalize">{t("city")}</p>
            <p className="text-gray-800 font-medium">{owner.city || "N/A"}</p>
          </div>
        </div>

        {/* Profile Status */}
        <div className="flex items-center gap-3 p-4 bg-gray-50 rounded-xl shadow-sm md:col-span-2">
          {owner.isCompletedProfile ? (
            <CheckCircle className="w-6 h-6 text-green-500" />
          ) : (
            <XCircle className="w-6 h-6 text-red-500" />
          )}
          <div>
            <p className="text-gray-500 text-sm capitalize">{t("profileCompleted")}</p>
            <p className={`font-medium capitalize ${owner.isCompletedProfile ? "text-green-600" : "text-red-600"}`}>
              {owner.isCompletedProfile ? t("yes") : t('no')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OwnerDetailsCard;
